import z from "zod";

export const projectDetailsFormSchema = z.object({
  sinopse: z.string().min(1, "Sinopse é obrigatória"),
  negociacao: z.string().min(1, "Negociação é obrigatória"),
  step: z.string().min(1, "Etapa é obrigatória"),
  protocol: z.string().min(1, "Protocolo ou Registro da obra Biblioteca Nacional é obrigatório"),
  janelas_exibicao: z.string().min(1, "Janelas de Exibição é obrigatória"),
  uf: z.string().min(1, "UF é obrigatória"),
  country: z.string().min(1, "País é obrigatório"),
  approvedValue: z.string().min(1, "Valor aprovado é obrigatório"),
  capturedValue: z.string().min(1, "Valor captado é obrigatório"),
  language: z.string().min(1, "Idioma é obrigatório"),
  time: z.string().min(1, "Tempo Total é obrigatório"),
});

export type ProjectDetailsFormData = z.infer<typeof projectDetailsFormSchema>;